import React from "react";
import "./css/ilustration.css";
import { motion } from "motion/react";
import IlustrationModal from "../modals/ilustrationModal/IlustrationModal";
import BlackWhileModal from "../modals/blackWhileModal/BlackWhileModal";
import ilustration from "./json/ilustrations.json";
import blackwhite from "./json/blackwhile.json";

const Ilustration = ({ images }) => {

  const handleOpenCoverModal = (id) => {
    const modal = new window.bootstrap.Modal(
      document.getElementById(id==1 ? "fullscreenIlustrationModal" : "fullscreenBlackWhileModal" )
    );
    modal.show();
  };


  return (
    <div className="container my-5">
      <div className="d-flex justify-content-center gap-5 flex-wrap">
        {images.map((img) => (
          <motion.div
            key={img.id}
            whileHover={{ scale: 1.1 }}
            whileTap={{ scale: 0.8 }}
            className="mx-4"
          >
            <div 
              className="gallery-item-illustration position-relative overflow-hidden rounded-4 cursor-pointer" 
              onClick={() => handleOpenCoverModal(img.id)}>
              <img
                src={img.img}
                alt={img.alt}
                className="img-fixed-ilustrations-hv"
              />
              <div className="text-overlay d-flex justify-content-center align-items-center">
                <div className="color-text-gris-28-hv">{img.title}</div>
              </div>
              <div className="overlay d-flex flex-column justify-content-center align-items-center text-center px-3">
                <div className="color-text-gris-28-hv">{img.title}</div>
                <div className="color-text-20-hv mt-3">{img.subtitle}</div>
              </div>
            </div>
          </motion.div>
        ))}

        <IlustrationModal ilustration={ilustration} />
        <BlackWhileModal blackWhite={blackwhite} />


      </div>
    </div>
  );
};

export default Ilustration;
